import React from "react";
import AuthForm from "../../forms/signup_form/signup_form";

const AuthFormComponent = ({ onAuthSubmit }) => {
  return <AuthForm onAuthSubmit={onAuthSubmit} />;
};

export default AuthFormComponent;
